import React from "react"
import { FaSearch } from "react-icons/fa"; 
import SimpleBar from 'simplebar-react'; 

export const SearchCategoryCheck = ({title}) => {
    const [search,setSearch] = React.useState('');

    return (
        <div className="category"> 
            <div className="search_category_check">
            {/**   {title && <h3 className="category_title" >{title}</h3>} */}
                <div className="searching">
                    <input 
                            name=""
                            placeholder="Search"
                            value={search}
                            onChange={(e)=>setSearch(e.target.value)}
                    />
                    <FaSearch />
                </div>
                <SimpleBar style={{ maxHeight: 150 }}>
                    <ul className="category_check_lists">
                        <li>
                            <input type="checkbox" id="c11" />
                            <label htmlFor="c11"> Food Services  <div className="counter">(63921-91455)</div></label>
                        </li>
                        <li>
                            <input type="checkbox" id="c12" />
                            <label htmlFor="c12">Social Assistance <div className="counter">(703-943)</div></label>
                        </li>
                        <li>
                            <input type="checkbox" id="c13" />
                            <label htmlFor="c13"> Finance and Insurance  <div className="counter">(7503-3089)</div></label>
                        </li>
                        <li>
                            <input type="checkbox" id="c13" />
                            <label htmlFor="c13"> Healthcare  <div className="counter">(2513-7005)</div></label>
                        </li>
                      
                    </ul>
            </SimpleBar>

            </div>
        </div>
    
    )
} 

